import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import FormEntryApi from './FormEntryApi';
import FormEntryActions from './Components/FormEntryActions';

let settings;

export default settings = {
    key: 'shop/form-entries',
    zone: 'shop',
    path: '/shop/form-entries',
    title: "Form Entry",
    endpoint: FormEntryApi.endpoint,
    modelName: 'FormEntry',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewFormEntry"],
    viewCaps: ["viewFormEntry"],
    createCaps: ["createFormEntry"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create"
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            // {
            //     label: "Add New",
            //     path: settings.path + '/create',
            //     caps: settings.createCaps
            // }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: FormEntryApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['form', 'owner', 'order', 'product'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Form",
                key: "formId",
                type: "relationship",
                model: "Form",
            },
            {
                label: "User",
                key: "ownerId",
                type: "relationship",
                model: "Users",
            },
            {
                label: "Product",
                key: "productId",
                type: "relationship",
                model: "Product",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Entry ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Form",
                key: "form",
                format: "ModelLink",
            },
            {
                label: "User",
                key: "owner",
                format: "ModelLink",
            },
            {
                label: "Order",
                key: "order",
                format: "ModelLink",
            },
            {
                label: "Product",
                key: "product",
                format: "ModelLink",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <FormEntryActions data={data} />;

                }
            }
        ];

        return columns;

    },

    indexExportFormats: (routeName, params, user) => {

        const formats = [
            { value: "formEntries", label: "Form Entries" }
        ];

        return formats;

    },

    singleFetch: FormEntryApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['form', 'owner', 'order', 'product'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            // {
            //     label: "Edit",
            //     path: path + "/edit"
            // },
        ]

    },
};